import React from "react";
import {
  Box,
  Typography,
  Divider,
  Link,
  Stack,
  Card,
} from "@mui/material";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import { useLocation } from "react-router-dom";
import orderThatIconWhite from "../Images/orderThatIconWhite.png";
import TermsSection from "./components/TermsSection";
import { useThemeColors } from "../Context/Theme";

const TermsAndConditions = () => {
  const {
    fontFamily,
    fontWeight,
    fontSize,
    fontFamilyHeading,
    fontWeightHeading,
    fontSizeHeading
  } = useThemeColors();
  const location = useLocation();

  const  { isAtAllEvents} = location.state || {};

  const eventName = sessionStorage.getItem("eventName");

  const AtAllEvents = isAtAllEvents ? true : false;
  return (
    <>
      <Navbar isAtAllEvents={eventName === "terms&conditions" ? true : AtAllEvents} />
      <Stack
        width={"100%"}
        paddingTop={"20px"}
        paddingBottom={"20px"}
        sx={{
          backgroundColor: "#f9f9f9",
        }}
        direction="column"
        alignItems="center"
      >
        <Card
          elevation={0}
          sx={{
            padding: { xs: 2, sm: 4 },
            color: "#333",
            mt: "15vh",
            minHeight: "70vh",
            width: "70%",
            borderRadius: "32px",
            border: "1px solid #D9D9D9",
          }}
        >
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            spacing={2}
          >
            <Divider
              sx={{
                flex: 1,
                height: "4px",
                bgcolor: "rgb(254, 59, 62)",
                opacity: 1,
              }}
            />
            <Typography
              variant="h4"
              fontWeight="800"
              sx={{ textAlign: "center", color: "#333", fontFamily: fontFamilyHeading, fontSize: fontSizeHeading, fontWeight: fontWeightHeading }}
            >
              Terms and Conditions
            </Typography>
            <Divider
              sx={{
                flex: 1,
                height: "4px",
                bgcolor: "rgb(254, 59, 62)",
                opacity: 1,
              }}
            />
          </Stack>
          <Typography
            variant="subtitle1"
            color="textSecondary"
            gutterBottom
            sx={{ textAlign: "center", fontFamily }}
          >
            (Last Updated: December 19, 2024)
          </Typography>

          <Divider sx={{ marginY: 3, height: "2px", bgcolor: "#D9D9D9" }} />

          <Typography variant="body1" gutterBottom style={{fontSize, fontFamily, fontWeight}}>
            <span style={{ color: "rgb(254, 59, 62)", fontWeight: "bold" }}>
              IMPORTANT NOTICE :
            </span>{" "}
            These Terms and Conditions ("Terms") establish the legally binding
            obligations between you ("User") and OrderThat LLC ("Company," "we,"
            "our," or "us"). By engaging with the App, you acknowledge and agree
            to these Terms.{" "}
            <span style={{ fontWeight: "bold" }}>
              Non-acceptance of these terms requires immediate discontinuation
              of app usage.
            </span>
          </Typography>

          <Divider sx={{ marginY: 3, height: "2px", bgcolor: "#D9D9D9" }} />

          <TermsSection
            title="Scope of Permissible Use"
            items={[
              "The App is made available for strictly non-commercial, lawful, and personal use. Unauthorized engagement, such as exploitation, modification, or reproduction, is forbidden.",
              "The Company retains the unilateral authority to restrict or terminate User access to the App without prior notice for suspected breaches.",
            ]}
          />
          <TermsSection
            title="Account Responsibilities"
            items={[
              "To use certain features of the App, you may be required to create an account.",
              "Users must provide accurate and complete information for account creation. Inaccuracies are a breach of these Terms.",
              "Users are responsible for safeguarding their account credentials. Unauthorized access due to negligence is disclaimed by the Company.",
              <>
                Notify the Company immediately at{" "}
                <a href="mailto:support@orderthat.com">support@orderthat.com</a>{" "}
                if you suspect unauthorized access.
              </>,
            ]}
          />
          <TermsSection
            title="Order Placement and Acceptance"
            items={[
              "Orders submitted via the App must be placed on or before the deadline as detailed on the specific event e-commerce page.",
              "Orders are finalized upon confirmation, subject to inventory availability, and can be canceled or modified at any time before pickup.",
              "By initiating an order, Users irrevocably authorize the Company to process payment for the full amount via the selected payment method.",
            ]}
          />
          <TermsSection
            title="Order Pickup Provisions"
            items={[
              "Users are required to retrieve orders at the specified location within the designated timeframe.",
              "Presentation of the unique QR code issued upon order confirmation is a prerequisite for order retrieval. QR codes can be stored in Apple or Google Wallet for convenience. Users who lose their QR codes can access order details through the App or verify their identity at the pickup location with a valid government ID.",
              "Any orders not picked up by the close of the designated period will be refunded within 30 business days following the conclusion of the event.",
            ]}
          />
          <TermsSection
            title="Refund and Return Policy"
            items={[
              "Event Cancellation: In the event of event cancellation, Users shall be entitled to a refund of the full purchase price.",
              "Voluntary Cancellations: Users may cancel their orders for a full refund at any time prior to pickup by following processes on the app, or by contacting customer service via the help portal or hello@orderthat.com.",
              "Defective Merchandise: Any items identified as defective at the point of pickup may be eligible for replacement or refund, subject to verification by the Company’s representatives.",
              "Alcohol-Specific Refunds: If alcoholic beverages are part of an order and cannot be released due to failure to provide valid identification, the alcoholic portion of the order will be refunded. Any bundling discounts applicable will be removed from the entire order, and the refund provided will equal the remaining value of the item returned or cancelled after subtracting the total discount for the bundle.",
              "Bundled or Discounted Items: In the event that an item purchased as part of a bundle or multi-product discount is returned or refunded, the applicable bundle or discount will be voided. The refund amount for the returned item will be calculated based on the difference between the item's full retail price and the discounted price at which it was purchased as part of the bundle or offer. The refund will be in the amount of the item price charged to the customer, after subtracting the total value of the applicable discount or bundle.",
            ]}
          />
          <TermsSection
            title="Alcohol Policy"
            items={[
              "Users must be 21 years of age or older to purchase alcoholic beverages. Proof of age through a valid government-issued photo ID is required upon pickup.",
              "Failure to present valid identification will result in the removal of alcoholic beverages from the order and a refund of their purchase price. The remaining items will be processed without adjustment, provided that item was not a component of a bundle or discount. In that case, refund amount will be calculated as detailed in section 5.5.",
            ]}
          />
          <TermsSection
            title="Pricing and Financial Transactions"
            items={[
              "Prices displayed within the App are subject to revision without prior notification. The price in effect at the time of order placement shall govern the transaction.",
              "Full payment is required contemporaneously with order placement. Non-payment or incomplete payment constitutes an actionable breach of these Terms.",
              "Chargebacks or disputes regarding payment may precipitate account suspension, imposition of fees, and/or initiation of collection procedures.",
            ]}
          />
          <TermsSection
            title="Prohibited User Conduct"
            items={[
              "Engaging in deceptive or fraudulent activities.",
              "Disseminating unsolicited advertisements or harmful software via the App.",
              "Disrupting, compromising, or attempting unauthorized access to the App’s systems or data.",
            ]}
          />

          <TermsSection
            title="Intellectual Property Rights"
            items={[
              "All proprietary rights, including intellectual property rights, pertaining to the App and its content, remain vested exclusively in the Company.",
              "Users are afforded a limited, non-transferable license for personal usage of the App. Unauthorized exploitation, redistribution, or derivative works are strictly prohibited.",
            ]}
          />

          <TermsSection
            title="Disclaimers and Limitations of Liability"
            items={[
              `THE APP IS PROVIDED \"AS IS\" AND \"AS AVAILABLE\" WITHOUT WARRANTIES OF ANY KIND. ALL IMPLIED WARRANTIES, INCLUDING MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT, ARE EXPRESSLY DISCLAIMED TO THE MAXIMUM EXTENT PERMITTED BY LAW.`,
              "THE COMPANY SHALL NOT BE LIABLE FOR INDIRECT, INCIDENTAL, CONSEQUENTIAL, OR EXEMPLARY DAMAGES, INCLUDING BUT NOT LIMITED TO LOSS OF PROFITS OR DATA.",
              "THE COMPANY’S LIABILITY SHALL NOT EXCEED THE AGGREGATE AMOUNT PAID BY THE USER FOR THE SPECIFIC ORDER IN QUESTION.",
            ]}
          />

          <TermsSection
            title="Indemnification"
            items={[
              "Users agree to indemnify and hold harmless the Company, its affiliates, officers, and employees against any claims, damages, or losses arising from:",
            ]}
          />

          <TermsSection
            nested={true}
            title=""
            items={[
              "1. User’s breach of these Terms;",
              "2. User’s misuse of the App; or",
              "3. User-submitted content.",
            ]}
          />

          <TermsSection
            title="Amendment of Terms"
            items={[
              "The Company retains the right to amend these Terms at its sole discretion. Amendments shall become effective upon their publication within the App.",
              "Continued use of the App constitutes binding acceptance of any amendments.",
            ]}
          />

          <TermsSection
            title="Governing Law and Jurisdiction"
            items={[
              "These Terms shall be governed and interpreted exclusively under the laws of the State of Delaware.",
              "Disputes shall be resolved exclusively within Delaware's jurisdiction.",
            ]}
          />
          <TermsSection
            title="Severability"
            items={[
              "If any provision of these Terms is held to be invalid or unenforceable, that provision will be struck from these Terms and the remaining provisions will remain in full force and effect.",
            ]}
          />
          <TermsSection
            title="Scope of Permissible Use"
            items={[
              "The App is made available for strictly non-commercial, lawful, and personal use. Unauthorized engagement, such as exploitation, modification, or reproduction, is forbidden.",
              "The Company retains the unilateral authority to restrict or terminate User access to the App without prior notice for suspected breaches.",
            ]}
          />

          <Typography variant="h6" sx={{ marginTop: 3, textAlign: "center", fontFamily: fontFamilyHeading, fontSize: fontSizeHeading, fontWeight: fontWeightHeading }}>
            Contact Us
          </Typography>
          <Typography variant="body1" sx={{ textAlign: "center" }} gutterBottom style={{fontFamily, fontSize, fontWeight}}>
            If you have any questions about these Terms, please contact us at{" "}
            <Link href="mailto:hello@orderthat.com">hello@orderthat.com</Link>.
          </Typography>

          <Divider sx={{ marginY: 3, height: "2px", bgcolor: "#D9D9D9" }} />

          <Typography variant="body2" color="textSecondary" textAlign="center" style={{fontFamily, fontWeight, fontSize}}>
            By utilizing the App, Users affirmatively acknowledge their
            comprehensive understanding and unqualified acceptance of these
            Terms.
          </Typography>
        </Card>
      </Stack>
      <Footer isAtAllEvents={AtAllEvents} icon={orderThatIconWhite} />
    </>
  );
};

export default TermsAndConditions;
